import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class CurrencyModel extends Model {
  static reducer(action, CurrencyModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.Currency.schema:
        action.payload.forEach((payload) => {
          const dbData = CurrencyModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          CurrencyModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
CurrencyModel.modelName = "CurrencyModel";

CurrencyModel.fields = {
  id: attr(),
};

export default CurrencyModel;